// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080423/js/" + chunkId + "." + {"44":"879b1c70","225":"3f72f3c8","481":"f7102957","486":"ced80e88","770":"0f186209"}[chunkId] + ".0.698566716883196.chunk.js";
};